module.exports = __webpack_public_path__ + "static/media/waves_2.c214efc9.jpg";